import { Routes as ReactRoutes, Route } from "react-router-dom";
import { Login } from "./pages/Login";
// import { Register } from "./pages/Register";
import { ThemeToggle } from "./components/ThemeToggle";

export function AuthRoutes() {
    return (
        <>
            <ThemeToggle />
            <ReactRoutes>
                <Route path="/login" element={<Login />}/>
                {/* <Route path="/cadastro" element={<Register />}/> */}
                <Route path="/cadastro" element={
                    <div className="flex h-screen items-center justify-center bg-gray-50 dark:bg-dark-bg">
                        <div className="text-center">
                            <h1 className="text-6xl font-bold text-gray-900 dark:text-white">404</h1>
                            <p className="mt-4 text-gray-600 dark:text-gray-400">Página não encontrada</p>
                        </div>
                    </div>
                } />
                <Route path="*" element={<Login />}/>
            </ReactRoutes>
        </>
    );
}